var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 29.5196C14.93 29.5196 14.36 29.3096 13.95 28.9196C13.43 28.4296 13.18 27.6896 13.27 26.8896L13.64 23.6496C13.71 23.0396 14.08 22.2296 14.51 21.7896L22.72 13.0996C24.77 10.9296 26.91 10.8696 29.08 12.9196C31.25 14.9696 31.31 17.1096 29.26 19.2796L21.05 27.9696C20.63 28.4196 19.85 28.8396 19.24 28.9396L16.02 29.4896C15.85 29.4996 15.7 29.5196 15.54 29.5196ZM25.93 12.9096C25.16 12.9096 24.49 13.3896 23.81 14.1096L15.6 22.8096C15.4 23.0196 15.17 23.5196 15.13 23.8096L14.76 27.0496C14.72 27.3796 14.8 27.6496 14.98 27.8196C15.16 27.9896 15.43 28.0496 15.76 27.9996L18.98 27.4496C19.27 27.3996 19.75 27.1396 19.95 26.9296L28.16 18.2396C29.4 16.9196 29.85 15.6996 28.04 13.9996C27.24 13.2296 26.55 12.9096 25.93 12.9096Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3404 20.9508C27.3204 20.9508 27.2904 20.9508 27.2704 20.9508C24.1504 20.6408 21.6404 18.2708 21.1604 15.1708C21.1004 14.7608 21.3804 14.3808 21.7904 14.3108C22.2004 14.2508 22.5804 14.5308 22.6504 14.9408C23.0304 17.3608 24.9904 19.2208 27.4304 19.4608C27.8404 19.5008 28.1404 19.8708 28.1004 20.2808C28.0504 20.6608 27.7204 20.9508 27.3404 20.9508Z",
    fill: "#0D2645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32.75H13C12.59 32.75 12.25 32.41 12.25 32C12.25 31.59 12.59 31.25 13 31.25H31C31.41 31.25 31.75 31.59 31.75 32C31.75 32.41 31.41 32.75 31 32.75Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditJob);
export default __webpack_public_path__ + "static/media/edit-job.5d6eb8a4bb6f550d1b1479e04b87e1a6.svg";
export { ForwardRef as ReactComponent };